import { useState, useEffect } from 'react'
import { ajax } from '@src/utils/ajax'

import { StatisticsPayload } from '../types'

export const useStatisticsData = () => {
  const [data, setData] = useState<StatisticsPayload>()
  const [isFetching, setIsFetching] = useState(false)

  const fetchData = () => {
    setIsFetching(true)
    ajax
      .get<StatisticsPayload>('/elama-index/graphics')
      .then(response => {
        setData(response.data)
      })
      .finally(() => {
        setIsFetching(false)
      })
  }

  useEffect(fetchData, [])

  return {
    data,
    isFetching
  }
}
